import React from 'react'
import { MdApartment, MdHome, MdPhoneIphone, MdWeb } from 'react-icons/md'
import { NavLink, useNavigate } from 'react-router-dom'
import logo from '@assets/icons/logo.svg'

interface IButtonSidebarItem {
    name: string,
    path?: string,
    subItems?: Array<IButtonSidebarItem>
    isDisabledClick?: boolean
    icon?: React.ReactElement,
}

export default function Sidebar(): React.ReactElement {
    const navigate = useNavigate()

    const buttonsSideBar: Array<IButtonSidebarItem> = [
        {
            icon: <MdHome className="icon-side" />,
            name: 'Home',
            path: '/'
        },
        {
            icon: <MdApartment className="icon-side" />,
            name: 'Imóveis',
            path: '/imoveis',
            subItems: [
                {
                    name: 'Tabela de Vendas',
                    path: '/tabela-de-vendas'
                },
                {
                    name: 'Apartamentos',
                    path: '/apartamentos'
                },
                {
                    name: 'Configurações',
                    path: '/configuracoes'
                }
            ]
        },
        {
            icon: <MdWeb className="icon-side" />,
            name: 'Site',
            path: '/undefined',
            isDisabledClick: true,
            subItems: [
                {
                    name: 'Clientes',
                    path: '/clientes'
                },
                {
                    name: 'Manutenções',
                    path: '/manutencoes'
                },
                {
                    name: 'Contatos',
                    path: '/contatos'
                },
                {
                    name: 'Usuários Admin',
                    path: '/administradores'
                }
            ]
        },
        {
            icon: <MdPhoneIphone className="icon-side" />,
            name: 'App',
            path: '/undefined',
            isDisabledClick: true,
            subItems: [
                {
                    name: 'Corretores',
                    path: '/corretores'
                },
                {
                    name: 'Destaques',
                    path: '/destaques'
                },
                // {
                //     name: 'FAQ',
                //     path: '/relatorios'
                // }
            ]
        },
    ]

    return (
        <div className="sidebar">
            <img
                width="170px"
                src={logo}
                alt="Logo CNA construtora"
                className="logo"
                onClick={() => navigate('/')}
            />

            <div className="menu">
                {buttonsSideBar.map((button, i) => {
                    return (
                        <React.Fragment key={i}>
                            <NavLink
                                {...(button.isDisabledClick && { onClick: e => e.preventDefault() })}
                                to={button.path as string}
                                className={`item-side ${button.isDisabledClick ? 'isDisabledClick' : ''}`}
                            >
                                {button.icon}
                                <p>{button.name}</p>
                            </NavLink>

                            {button.subItems ? (
                                <div className="sub-items">
                                    {button.subItems.map((subItem, j) => {
                                        return (
                                            <NavLink
                                                className="sub-item-button"
                                                to={subItem.path as string}
                                                key={j}
                                            >
                                                {subItem.name}
                                            </NavLink>
                                        )
                                    })}
                                </div>
                            ) : (
                                <></>
                            )}
                        </React.Fragment>
                    )
                })}
            </div>
        </div>
    )
}
